import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { Brightness4, Brightness7 } from '@mui/icons-material'
import { inject, observer } from 'mobx-react'
import { IStores } from '../../Stores'

interface IDarkModeToggleProps {
  isDarkMode?: boolean
  toggleDarkMode?: () => void
}

@inject((stores: IStores) => ({
  isDarkMode: stores.global.isDarkMode,
  toggleDarkMode: stores.global.toggleDarkMode,
}))
@observer
class DarkModeToggle extends React.Component<IDarkModeToggleProps> {
  public render() {
    const { isDarkMode, toggleDarkMode } = this.props

    return (
      <Tooltip
        title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        placement="right"
      >
        <IconButton onClick={toggleDarkMode} color="inherit">
          {isDarkMode ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
      </Tooltip>
    )
  }
}

export default DarkModeToggle
